import React from 'react';
import { RoundTableBilling, BillingPosition } from './wizardTypes';

interface WizardStep4Props {
    roundTableBillings: RoundTableBilling[];
    setRoundTableBillings: (billings: RoundTableBilling[]) => void;
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    positions: BillingPosition[];
    toggleBillingSelection: (roundTableId: number) => void;
}

const WizardStep4: React.FC<WizardStep4Props> = ({
    roundTableBillings,
    setRoundTableBillings,
    searchQuery,
    setSearchQuery,
    positions,
    toggleBillingSelection,
}) => {
    const filteredBillings = roundTableBillings.filter(b => 
        b.roundTable.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        b.roundTable.number.toString().includes(searchQuery)
    );

    return (
        <div className="wizard-step wizard-step-review">
            <h3>Überprüfung</h3>
            
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Suche nach Name oder Nummer..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <div className="review-table-container">
                <table className="review-table">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    checked={roundTableBillings.every(b => b.selected)}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setRoundTableBillings(roundTableBillings.map(b => ({ ...b, selected: checked })));
                                    }}
                                />
                            </th>
                            <th>Nummer</th>
                            <th>Name</th>
                            <th>Positionen</th>
                            {positions.some(p => p.priceType === 'perTabler') && <th>Tabler</th>}
                            <th>Betrag</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredBillings.map(billing => (
                            <tr key={billing.roundTable.id} className={billing.selected ? 'selected' : ''}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={billing.selected}
                                        onChange={() => toggleBillingSelection(billing.roundTable.id)}
                                    />
                                </td>
                                <td>{billing.roundTable.number}</td>
                                <td>{billing.roundTable.name}</td>
                                <td>
                                    <div className="positions-summary">
                                        {billing.positions.map(pos => (
                                            <div key={pos.id} className="position-summary-item">
                                                {pos.description} ({pos.taxRate}% MwSt.)
                                            </div>
                                        ))}
                                    </div>
                                </td>
                                {positions.some(p => p.priceType === 'perTabler') && (
                                    <td>{billing.tablerCount}</td>
                                )}
                                <td className="amount-cell">{billing.totalAmount.toFixed(2)} €</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="review-summary">
                <strong>Ausgewählt:</strong> {roundTableBillings.filter(b => b.selected).length} von {roundTableBillings.length}
                <span className="total-amount">
                    Gesamtsumme: {roundTableBillings.filter(b => b.selected).reduce((sum, b) => sum + b.totalAmount, 0).toFixed(2)} €
                </span>
            </div>
        </div>
    );
};

export default WizardStep4;
